import { type PropsWithChildren } from "react"
import { GridItem, Stack } from "@octopus-energy/coral/atoms"

export function DashboardLayoutMain({ children }: PropsWithChildren) {
    return (
        <GridItem gridArea="main">
            <Stack
                flexDirection="column"
                gap="lg"
            >
                {children}
            </Stack>
        </GridItem>
    )
}
